// project-imports

import Settings from './Settings';
import Category from './category';
import Division from './Stream';

import Groups from './groups';
import Course from './course';

import Events from './events';
import Report, { facultyReport } from './report';

import Notification from './Notification';
import { NavItemType } from 'types/menu';
import Blogs from './Blogs';

import Badges from './badges';

import Access from './access';

import Timetable from './Timetable';

import Discussions from './Discussion';
import Organization from './organization';
import Packages from './Packages';
import AssignPackage from './AssignPackage';
import SuperAdminUser from './SuperAdminUser';

import Feedback from './Feedback';
import Contact from './Contact';
import Exam from './Exam';

import Tickets from './ticket';

import Chat from './chats';

import { FacultyUsers } from './users';

import Meeting from './meeting';

import superAdminBlogs from './superAdminBlogs';
import SuperAdminContacts from './SuperAdminContacts';
import superAdminCMS from './superAdminCMS';
import courseSupAdmin from './courseSupAdmin';

import LandingPageManagement from './LandingPageManagement';
import Timeline from './Timeline';
import TransferStudents from './transferStudent';
import { CustomNotification, SuperAdminCustomNotification } from './CustomNotification';
import SuperAdminTickets from './SuperAdminTickets';
import superAdminQuestionBank from './SuperAdmiQuestionBank';
import Whiteboard from './whiteboard';
import PlanLearning from './planLearning';
import { SuperAdminErrorLogs } from './ErrorLogs';
import SuperAdminEmailTemplateNotification from './SuperAdminEmailTemplateNotification';
import AiLessonPlanner from './AiLessonPlanner';
import PackageHistory from 'menu-items/PackageHistory';
import SuperAdminAppVersion from 'menu-items/SuperAdminAppVersion';
import Attendance from 'menu-items/Attendance';
import TrainingCenter from './TrainingCenter';
import Batches from './batches';
// ==============================|| MENU ITEMS ||============================== //
interface UserTypeProps {
  superadmin: Array<NavItemType>;
  admin: Array<NavItemType>;

  student?: Array<NavItemType>;
  faculty: Array<NavItemType>;
}
const userType: UserTypeProps = {
  superadmin: [
    Organization,
    SuperAdminUser,
    Packages,
    AssignPackage,
    PackageHistory,

    SuperAdminTickets,
    SuperAdminContacts,
    superAdminBlogs,
    courseSupAdmin,
    superAdminCMS,
    LandingPageManagement,
    SuperAdminCustomNotification,
    superAdminQuestionBank,
    SuperAdminErrorLogs,
    SuperAdminEmailTemplateNotification,
    SuperAdminAppVersion
  ],

  admin: [
    TrainingCenter,
    // TimeTableSchedulerMenu,
    Timetable,
    Attendance,
    // TimeTableSchedulerMenu,
    Category,
    Division,
    Course,
    Whiteboard,
    Groups,
    Batches,
    Exam,
    Chat,
    PlanLearning,
    AiLessonPlanner,
    Discussions,

    Access,
    Events,
    Badges,

    Meeting,

    Notification,

    Blogs,
    TransferStudents,

    Tickets,
    Report,
    Feedback,
    Contact,
    Settings,

    Timeline,
    CustomNotification
  ],

  faculty: [
    FacultyUsers,
    Attendance,
    Category,
    Division,
    Course,
    Whiteboard,
    Groups,

    Exam,
    Chat,
    PlanLearning,
    AiLessonPlanner,
    Tickets,
    Events,
    Meeting,
    Discussions,
    facultyReport,
    Settings,
    Timeline,
    CustomNotification
  ]
};

export default userType;
